import script from "./ReservasView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservasView.vue?vue&type=script&setup=true&lang=js"

import "./ReservasView.vue?vue&type=style&index=0&id=92b760ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92b760ba"]])

export default __exports__